import { Box, Stack, Typography } from "@mui/material";
import type { DocumentInfo } from "../../../../../../api/types/documentCollectionTypes";
import CategoryTag from "../../../../../common/CategoryTag";

interface Props {
  document: DocumentInfo;
}

const DocumentPreviewHeader = ({ document }: Props) => (
  <Stack spacing={1} sx={{ mb: 2, ml: 1.5 }}>
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography variant="subtitle1">{document.name}</Typography>
      <CategoryTag externalCategoryId={document.categoryId} />
    </Box>

    <Stack direction="row" spacing={1}>
      {document.investorTitle && <Typography>{document.investorTitle}</Typography>}
      {document.fundName && <Typography>&bull;</Typography>}
      {document.fundName && <Typography>{document.fundName}</Typography>}
    </Stack>
  </Stack>
);

export default DocumentPreviewHeader;
